module.exports = __webpack_public_path__ + "img/w57.8651bac7.svg";